import React, { useEffect, Component } from "react";
import { Router, Route, Routes, useLocation, Navigate } from "react-router-dom";

import { Helmet, renderStatic } from "react-helmet";

import RedirectSubpage from "./RedirectSubpage";
import FacultyProfile from "./FacultyProfile";

// import RoutesDefault from './RoutesDefault';
// import RoutesOne from './RoutesOne';
// import RoutesTwo from './RoutesTwo';
// import RoutesThree from './RoutesThree';
// import RoutesFour from './RoutesFour';
// import PageNotFound from '../component/IITTP/PageNotFound';

import Home from "../component/home/Main";
import Footer from "../component/footer/Main";
// ---router 1 starts here--------
import AboutEle from "../component/IITTP/About/AboutEle";
import AboutLogo from "../component/IITTP/About/AboutLogo";
// Admission
import Admissionpg from "../component/IITTP/Admission/AdmissionPg";
import Phd_Admissionpg from "../component/IITTP/Admission/Phd_admissionPg";
import Visvesvaraya_Phd_Admissionpg from "../component/IITTP/Admission/Visvesvaraya_Phd_admissionPg";
// import Test_Phd_Admissionpg from '../component/IITTP/Admission/Test_Phd_admissionPg';
import Btech_Admissionpg from "../component/IITTP/Admission/btech_admissionPg";
import Ms_Admissionpg from "../component/IITTP/Admission/Ms_admissionPg";
// import Test_Ms_Admissionpg from '../component/IITTP/Admission/Test_Ms_admissionPg';
import Msc_admissionPg from "../component/IITTP/Admission/Msc_admissionPg";
import MPP_admissions_2023 from "../component/IITTP/Admission/MPP_admissions_2023";
// Academic
import AcademiCalenderpg from "../component/IITTP/Academic/AcademicCalenderPg";
import AcademicServicesPg from "../component/IITTP/Academic/AcademicServicesPg";
import AcademicTeam from "../component/IITTP/Academic/AcademicTeam";
// programme
import BtechPg from "../component/IITTP/Programmes/BtechPg";
import MtechPg from "../component/IITTP/Programmes/MtechPg";
import MtechSelfSponsoredPg from "../component/IITTP/Programmes/MtechSelfSponsoredPg";
import MscPg from "../component/IITTP/Programmes/MscPg";
import MasterOfPPMPg from "../component/IITTP/Programmes/MasterofPPMPg";
import MsPg from "../component/IITTP/Programmes/MsPg";
import PhdPg from "../component/IITTP/Programmes/PhdPg";
//statement-of-expenditure
import StatementExpenPg from "../component/IITTP/StatementExpenditure/StatementExpenPg";
//Fee Structure
import FeeStructurePg from "../component/IITTP/FeeStructure/FeeStructurePg";
import FeeRefund from "../component/IITTP/FeeStructure/FeeRefund";
// Scholarships
import Institute_UGscholarshipsPg from "../component/IITTP/Scholarships/Institute_UGscholarshipsPg";
import Institute_PGscholarshipsPg from "../component/IITTP/Scholarships/Institute_PGscholarshipsPg";
import AwardeesPg from "../component/IITTP/Scholarships/AwardeesPg";
import Institute_AISHE_CodePg from "../component/IITTP/Scholarships/Institute_AISHE_CodePg";
import PMVidyalaxmiSchemePg from "../component/IITTP/Scholarships/PMVidyalaxmiSchemePg";
import NationalScholarshipPortalPg from "../component/IITTP/Scholarships/NationalScholarshipPortalPg";
// ordinances
import OrdinancesPg from "../component/IITTP/Ordinances/OrdinancesPg";
// Curriculum
import Btech_CurriculumPg from "../component/IITTP/Curriculum/Btech_curriculumPg";
import Msc_curriculumPg from "../component/IITTP/Curriculum/Msc_curriculumPg";
import Mtech_curriculumPg from "../component/IITTP/Curriculum/Mtech_curriculumPg";
import Dualdegree_curriculumPg from "../component/IITTP/Curriculum/Dualdegree_curriculumPg";
import BtechMSDualdegree_curriculumPg from "../component/IITTP/Curriculum/BtechMSDualdegree_curriculumPg";
import MPP_curriculumPg from "../component/IITTP/Curriculum/MPP_curriculumPg";
import Honours from "../component/IITTP/Academic/Honours.js";

// ResearchScholar
import RS_ChemicalEng from "../component/IITTP/ResearchScholars/RS_ChemicalEng";
import RS_Chemistry from "../component/IITTP/ResearchScholars/RS_Chemistry";
import RS_CivilEng from "../component/IITTP/ResearchScholars/RS_CivilEng";
import RS_CSE from "../component/IITTP/ResearchScholars/RS_CSE";
import RS_EE from "../component/IITTP/ResearchScholars/RS_EE";
import RS_MS from "../component/IITTP/ResearchScholars/RS_MS";
import RS_ME from "../component/IITTP/ResearchScholars/RS_ME";
import RS_HSS from "../component/IITTP/ResearchScholars/RS_Hss";
import RS_Physics from "../component/IITTP/ResearchScholars/RS_Physics";
// ALL Staff
import DurgaprasadChalla from "../component/IITTP/Staffs/DurgaprasadChalla";
import SasidharGumma from "../component/IITTP/Staffs/SasidharGummaPg";
import S_Rajesh from "../component/IITTP/Staffs/S_Rajesh";
import Ankireddy_katha from "../component/IITTP/Staffs/Ankireddy_katha";
//other fellowships
import Pmrf_Scholars from "../component/IITTP/Other_Fellowships/Pmrf_Scholars";
import Pm_Fellowship from "../component/IITTP/Other_Fellowships/Pm_Fellowship";
//people
import Dept_CivilEng from "../component/IITTP/People/Dept_CivilEng";
import Dept_Chemistry from "../component/IITTP/People/Dept_Chemistry";
import Dept_ChemicalEng from "../component/IITTP/People/Dept_ChemicalEng";
import Dept_CSE from "../component/IITTP/People/Dept_CSE";
import Dept_EE from "../component/IITTP/People/Dept_EE";
import Dept_HSS from "../component/IITTP/People/Dept_HSS";
import Dept_Math from "../component/IITTP/People/Dept_Math";
import Dept_ME from "../component/IITTP/People/Dept_ME";
import Dept_Physics from "../component/IITTP/People/Dept_Physics";
import Dept_OthersFacult from "../component/IITTP/People/Dept_OthersFacult";
import Liaison_officers from "../component/IITTP/Committees/liaison_officers";
// import Policies from '../component/IITTP/Policy/Policy'
import Syllabus from "../component/IITTP/Academic/Syllabus";
import Minors from "../component/IITTP/Academic/Minors";
import Awards from "../component/IITTP/Awards/Award";
//Resource
import Infrastructure from "../component/IITTP/Resources/infrastructure";
import Computing_facilities from "../component/IITTP/Resources/computing-facilities";
import Resources_Academics from "../component/IITTP/Resources/Resources_Academics";
// Contact US
import ContactUS from "../component/IITTP/ContactUS/ContactUS";
// Others
import Openhouse from "../component/IITTP/Others/Openhouse";
import Committees from "../component/IITTP/Committees/CommitteesPg";
import InternalComplaint from "../component/IITTP/Committees/InternalComplaint";
import AntiRagging from "../component/IITTP/Committees/Anti_Ragging";
import Grievance_Redressal_Committee from "../component/IITTP/Committees/grievance_redressal_committee";
import Differently_Abled_Support_Service_Cell from "../component/IITTP/Committees/differently_abled_support_service_cell";
import Disciplinary_Welfare_Committee from "../component/IITTP/Committees/disciplinary_welfare_committee";
import School_Management_Committee from "../component/IITTP/Committees/school_management_committee";
import Senior_Purchase_Committee from "../component/IITTP/Committees/senior_purchase_committee";
import Overseeing_Waste_Management_System from "../component/IITTP/Committees/overseeing_waste_management_system";
import Mental_Health_and_Well_Being_Monitoring_Committee from "../component/IITTP/Committees/mental_health_and_well_being_monitoring_committee";
import Obc_cell from "../component/IITTP/Committees/obc_cell";
import Outsourcing_Contractual_Adhoc_Employee_Committee from "../component/IITTP/Committees/outsourcing_contractual_adhoc_employee_committee";
import Equal_Opportunity_Cell from "../component/IITTP/Committees/equal_opportunity_cell"; 
import Library_Advisory_Committee from "../component/IITTP/Committees/Library_Advisory_Committee";
import Timetable_Committee from "../component/IITTP/Committees/Timetable_Committee";
import Service_Matters_Committee from "../component/IITTP/Committees/Service_Matters_Committee";
import RPN_Committee from "../component/IITTP/Committees/RPN_Committee";
import Creche from "../component/IITTP/Others/creche";
import Kvsiittcampus from "../component/IITTP/Others/Kvsiittcampus";
import Information_for_btech_students from "../component/IITTP/Others/Information_for_btech_students";
import Help_desk_girl from "../component/IITTP/Others/Help_deskgirl";
import Bog_chairman from "../component/IITTP/Others/Bog_chairman";
import Alumni_Centres from "../component/IITTP/Others/Alumni_Centres";
import ISTEM from "../component/IITTP/Others/istem";
// Infrastructure
import Inter_iitsports from "../component/IITTP/Infrastructure/Inter_iitsports";
import InfrastructureCampus from "../component/IITTP/Infrastructure/InfrastructureCampus";
//Activities
import Social from "../component/IITTP/Activities/Social";
import Festival from "../component/IITTP/Activities/Festivals";
import Sports from "../component/IITTP/Activities/Sports";
import Club_Committee_Members from "../component/IITTP/Activities/Club_Committee_Members";
import Clubs from "../component/IITTP/Activities/Clubs";
import Tenders from "../component/IITTP/Tender/TenderJSON";
import TendersIEMs from "../component/IITTP/Tender/TendersIEMs";
import ComingSoon from "../component/IITTP/ComingSoon";

// ----router 2 start here
// Research
import ResearchThrustAreasPg from "../component/IITTP/Research/ResearchTrustAreasPg";
import ResearchProjectsPg from "../component/IITTP/Research/ResearchProjectsPg";
import ResearchEquipmentPg from "../component/IITTP/Research/ResearchEquipmentPg";
import IncubationPg from "../component/IITTP/Research/IncubationPg";
import PatentTechnologyTransferPg from "../component/IITTP/Research/PatentTechnologyTransferPg";
// Administration
import BoardOfGovernorsPg from "../component/IITTP/Administration/BoardOfGovernorsPg";
import AcademicAdministrationPg from "../component/IITTP/Administration/AcademicAdministrationPg";
import SenatePg from "../component/IITTP/Administration/SenatePg";
import FinanceComitteePg from "../component/IITTP/Administration/FinanceComitteePg";
import BuildingandWorkCommiteePg from "../component/IITTP/Administration/BuildingandWorkCommiteePg";
import OrganizationalStructurePg from "../component/IITTP/Administration/OrganizationalStructurePg";
//Academic
import FormsPg from "../component/IITTP/Academic/FormsPg";

import BtechTimetable from "../component/IITTP/Academic/BtechTimetable";

//Rajbhasha
import Rajbhasha from "../component/IITTP/Rajbhasha";

//Faqs
import FaqsPg from "../component/IITTP/Faqs/FaqsPg";
//Registrar
import RegistrarPg from "../component/IITTP/Registrar/RegistrarPg";
//Director
import DirectorPg from "../component/IITTP/Director/DirectorPg";
//Staffs
import Muthukumar_Palanisamy from "../component/IITTP/Staffs/Muthukumar_Palanisamy";
//AnnualReports
import AnnualReportsPg from "../component/IITTP/AnnualReports/AnnualReportsPg";
// ---router 3 starts here---
import TransportAdministrationPg from "../component/IITTP/Administration/TransportAdministrationPg";
import RTIAdministrationPg from "../component/IITTP/Administration/RTIAdministrationPg";
import RTISection4AdministrationPg from "../component/IITTP/Administration/RTISection4AdministrationPg";
// ---router 4 starts here---
// For students
import Publication from "../component/IITTP/Publication/Publication";
import HealthCentre from "../component/IITTP/HealthCenter/HealthCenter";
import Newsletter from "../component/IITTP/Newsletter/Newsletter";
import Announcements from "../component/IITTP/Announcements/Announcements";
import HomeEventList from "../component/IITTP/Events/HomeEventsList";
import EventSubmission from "../component/IITTP/Events/EventSubmission";
import Cultural from "../component/IITTP/Activities/CulturalPg";
// Admission
import MsPhdInternational_admissionPg from "../component/IITTP/Admission/MsPhdInternational_admissionPg";
import MtechInternational_admissionPg from "../component/IITTP/Admission/MtechInternational_admissionPg";
import Mtech_admissionPg from "../component/IITTP/Admission/Mtech_admissionPg";
// import Test_MtechSelfSponsored_admissionPg from "../component/IITTP/Admission/Test_MtechSelfSponsored_admissionPg";
import MtechSelfSponsored_admissionPg from "../component/IITTP/Admission/MtechSelfSponsored_admissionPg";
import MtechSpot_admissionPg from "../component/IITTP/Admission/MtechSpot_admissionPg";
import MPPadmissionPg from "../component/IITTP/Admission/MPP_admissionPg";
import TimeTablePg from "../component/IITTP/Academic/PgTimeTable";
import Admin_Staff from "../component/IITTP/People/Admin_Staff";
import PermanentCampus from "../component/IITTP/PermanentCampus/PermanentCampus";
import TechnicalTalks from "../component/IITTP/Events/TechnicalTalks";
import FacultyRecruitment from "../component/IITTP/Recruitment/FacultyRecruitment";
import Recruitment from "../component/IITTP/Recruitment/Recruitment";
import Interns_and_Apprentice from "../component/IITTP/Recruitment/Interns_and_Apprentice";
import Project_Positions from "../component/IITTP/Recruitment/Project_Positions";
import Outsourced_Positions from "../component/IITTP/Recruitment/Outsourced_Positions";
import Conferences from "../component/IITTP/Events/Conferences";
import DistinguishedLectures from "../component/IITTP/Events/DistinguishedLectures";
import News from "../component/IITTP/News/News";
import InstituteEvents from "../component/IITTP/Events/InstituteEvents";
import Workshops from "../component/IITTP/Events/Workshops";
import Past_Convocations from "../component/IITTP/Convocation/Past_Convocations";
import Error from "../component/Pages/error/Main";
import MSPHD_Admissions from "../component/IITTP/Admission/MsPhD_admissions";

import SwayamPrabha from "../component/IITTP/Others/SwayamPrabha";
import RecruitmentAdvertisements from "../component/Recruitment/ProtectedPage";

class HelmetWrapper extends React.Component {
  componentDidMount() {
    // Move side effect to componentDidMount
    window.scroll(0, 0);
    // Update the title dynamically in componentDidMount
    document.title = this.props.title;
  }

  componentDidUpdate(prevProps) {
    // Update the title when props change
    if (prevProps.title !== this.props.title) {
      document.title = this.props.title;
    }
  }

  render() {
    const { children } = this.props;
    return (
      <article>
        {/* Render children */}
        {children}
      </article>
    );
  }
}

const useNewFacultyProfile =
  process.env.REACT_APP_USE_NEW_FACULTY_PROFILE !== "false";

function FacultyProfileSwitch({ subpage, oldSubpage, oldElement }) {
  if (useNewFacultyProfile) {
    return <FacultyProfile subpage={subpage} />;
  }

  if (oldElement) {
    return oldElement;
  }

  return <RedirectSubpage subpage={oldSubpage || subpage} />;
}

function Index() {
  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <HelmetWrapper title="IITTirupati - Home Page">
              <Home />
            </HelmetWrapper>
          }
        />
        {/* About US */}
        <Route
          path="/aboutus"
          element={
            <HelmetWrapper title="IITTirupati - About Logo">
              <AboutEle
                activeIndex={0}
                title="About Us"
                titleHi="हमारे बारे में"
              />
            </HelmetWrapper>
          }
        />
        <Route
          path="/vision"
          element={<AboutEle activeIndex={1} title="Vision" titleHi="ध्येय" />}
        />
        <Route
          path="/mission"
          element={
            <AboutEle activeIndex={2} title="Mission" titleHi="लक्ष्य" />
          }
        />
        <Route
          path="/Objectives"
          element={
            <AboutEle activeIndex={3} title="Objectives" titleHi="उद्देश्य" />
          }
        />
        <Route
          path="/NIRF"
          element={<AboutEle activeIndex={4} title="NIRF" titleHi="एनआईआरएफ" />}
        />
        <Route
          path="/aboutlogo"
          element={
            <HelmetWrapper title="IITTirupati - About Logo">
              <AboutLogo />
            </HelmetWrapper>
          }
        ></Route>
        {/* Admission */}
        <Route
          path="/admissions"
          element={
            <HelmetWrapper title="IITTirupati - Admissions">
              <Admissionpg />
            </HelmetWrapper>
          }
        ></Route>

         {/* Admission */}
        <Route
          path="/recruitment-advertisements"
          element={
            <HelmetWrapper title="IITTirupati - Recruitment Advertisements">
              <RecruitmentAdvertisements />
            </HelmetWrapper>
          }
        ></Route>


        <Route
          path="/ph-d-admission"
          element={
            <HelmetWrapper title="IITTirupati - Ph-D-Admission">
              <Phd_Admissionpg />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/visvesvaraya-ph-d-admission"
          element={
            <HelmetWrapper title="IITTirupati - Visvesvaraya-Ph-D-Admission">
              <Visvesvaraya_Phd_Admissionpg />
            </HelmetWrapper>
          }
        ></Route>
        {/* <Route path="/test-ph-d-admission" element={<HelmetWrapper title="IITTirupati - Ph-D-Admission"><Test_Phd_Admissionpg /></HelmetWrapper>} ></Route> */}
        <Route
          path="/b-tech-admission"
          element={
            <HelmetWrapper title="IITTirupati - B-Tech-Admission">
              <Btech_Admissionpg />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/ms-admission"
          element={
            <HelmetWrapper title="IITTirupati - M.S(Research)-Admission">
              <Ms_Admissionpg />
            </HelmetWrapper>
          }
        ></Route>
        {/* <Route path="/test-ms-admission" element={<HelmetWrapper title="IITTirupati - M.S(Research)-Admission"><Test_Ms_Admissionpg /></HelmetWrapper>} ></Route> */}
        <Route
          path="/m-sc-admission"
          element={
            <HelmetWrapper title="IITTirupati - M.Sc-Admission">
              <Msc_admissionPg />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/mpp-admissions-2023"
          element={
            <HelmetWrapper title="IITTirupati - MPP-Admission">
              <MPP_admissions_2023 />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/msphd-admissions"
          element={
            <HelmetWrapper title="IITTirupati - MS PhD Admission">
              <MSPHD_Admissions />
            </HelmetWrapper>
          }
        ></Route>
        {/* Academic */}
        <Route
          path="/academic-calender"
          element={
            <HelmetWrapper title="IITTirupati - Academic Calender">
              <AcademiCalenderpg />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/academics/academic-calender"
          element={<Navigate to="/academic-calender" replace />}
        />
        <Route
          path="/academic-services"
          element={
            <HelmetWrapper title="IITTirupati - Academic Services">
              <AcademicServicesPg />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/guidelines-honours-programme"
          element={
            <HelmetWrapper title="IITTirupati - Guidelines for Honours Programme">
              <Honours />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/academics/academic-services"
          element={<Navigate to="/academic-services" replace />}
        />
        <Route
          path="/academic-team"
          element={
            <HelmetWrapper title="IITTirupati - Academic Team">
              <AcademicTeam />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/syllabus"
          element={
            <HelmetWrapper title="IITTirupati - Syllabus">
              <Syllabus />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/academics/syllabus"
          element={<Navigate to="/syllabus" replace />}
        />
        <Route
          path="/minors"
          element={
            <HelmetWrapper title="IITTirupati - Minors">
              <Minors />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/academics/minors"
          element={<Navigate to="/minors" replace />}
        />
        {/* Programme */}
        <Route
          path="/btech"
          element={
            <HelmetWrapper title="IITTirupati - B.Tech">
              <BtechPg />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/mtech"
          element={
            <HelmetWrapper title="IITTirupati - M.Tech">
              <MtechPg />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/mtech-self-sponsored"
          element={
            <HelmetWrapper title="IITTirupati - M.Tech. Self-Sponsored">
              <MtechSelfSponsoredPg />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/msc"
          element={
            <HelmetWrapper title="IITTirupati - MSC">
              <MscPg />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/master-of-public-policy-mpp"
          element={
            <HelmetWrapper title="IITTirupati - Master of Public Policy (MPP)">
              <MasterOfPPMPg />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/ms"
          element={
            <HelmetWrapper title="IITTirupati - MS">
              <MsPg />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/phd"
          element={
            <HelmetWrapper title="IITTirupati - Ph.D">
              <PhdPg />
            </HelmetWrapper>
          }
        ></Route>
        {/* Statement of Expenditure */}
        <Route
          path="/statement-of-expenditure"
          element={
            <HelmetWrapper title="IITTirupati - Statement of Expenditure">
              <StatementExpenPg />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/academics/statement-of-expenditure"
          element={<Navigate to="/statement-of-expenditure" replace />}
        />
        {/* Fee Structure */}
        <Route
          path="/fee-structure"
          element={
            <HelmetWrapper title="IITTirupati - Fee Structure">
              <FeeStructurePg />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/academics/fee-structure"
          element={<Navigate to="/fee-structure" replace />}
        />
        <Route
          path="/fee-refund-guidelines"
          element={
            <HelmetWrapper title="IITTirupati - Fee Refund Guidelines">
              <FeeRefund />
            </HelmetWrapper>
          }
        ></Route>
        {/* Scholarships  */}
        <Route
          path="/institute-scholarships"
          element={
            <HelmetWrapper title="IITTirupati - Institute Scholarships">
              <Institute_UGscholarshipsPg />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/scholarships-for-pg-students"
          element={
            <HelmetWrapper title="IITTirupati - Scholarships for PG Students">
              <Institute_PGscholarshipsPg />
            </HelmetWrapper>
          }
        ></Route>
        {/* scholarships/bonafides-scholarship-forms# */}
        <Route
          path="/institute-aishe-code"
          element={
            <HelmetWrapper title="IITTirupati - Bonafides & Scholarship">
              <Institute_AISHE_CodePg />
            </HelmetWrapper>
          }
        ></Route>
        {/* awardees */}
        <Route
          path="/awardees"
          element={
            <HelmetWrapper title="IITTirupati - Awardees">
              <AwardeesPg />
            </HelmetWrapper>
          }
        ></Route>
        {/* PM-Vidyalaxmi Scheme */}
        <Route
          path="/pm-vidyalaxmi-scheme"
          element={
            <HelmetWrapper title="IITTirupati - PM-Vidyalaxmi Scheme">
              <PMVidyalaxmiSchemePg />
            </HelmetWrapper>
          }
        ></Route>
        {/*	National Scholarship Portal (NSP) */}
        <Route
          path="/national-scholarship-portal"
          element={
            <HelmetWrapper title="IITTirupati - National Scholarship Portal (NSP)">
              <NationalScholarshipPortalPg />
            </HelmetWrapper>
          }
        ></Route>
        {/* 24  */}
        {/* ordinances */}
        <Route
          path="/ordinances"
          element={
            <HelmetWrapper title="IITTirupati - Ordinances">
              <OrdinancesPg />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/academics/ordinances"
          element={<Navigate to="/ordinances" replace />}
        />
        {/* Curriculum  */}
        <Route
          path="/b-tech-curriculum"
          element={
            <HelmetWrapper title="IITTirupati - B.Tech Curriculm">
              <Btech_CurriculumPg />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/m-tech-curriculum"
          element={
            <HelmetWrapper title="IITTirupati - M.Tech Curriculm">
              <Mtech_curriculumPg />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/dual-degree-curriculum"
          element={
            <HelmetWrapper title="IITTirupati - Dual Degree Curriculum">
              <Dualdegree_curriculumPg />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/btech-ms-dual-degree-curriculum"
          element={
            <HelmetWrapper title="IITTirupati - Dual Degree (B.Tech. + M.S.(R)) Curriculum">
              <BtechMSDualdegree_curriculumPg />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/m-sc-curriculum"
          element={
            <HelmetWrapper title="IITTirupati - M.Sc Curriculm">
              <Msc_curriculumPg />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/master-of-public-policy-mpp-curriculum"
          element={
            <HelmetWrapper title="IITTirupati - Master of Public Policy (MPP) Curriculum">
              <MPP_curriculumPg />
            </HelmetWrapper>
          }
        ></Route>
        {/* Research ScholarShip */}
        <Route
          path="/researchscholars-chemical-engineering"
          element={
            <HelmetWrapper title="IITTirupati - Chemical Engineering">
              <RS_ChemicalEng />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/academics/research-scholars/researchscholars-chemical-engineering"
          element={
            <Navigate to="/researchscholars-chemical-engineering" replace />
          }
        />
        <Route
          path="/researchscholars-chemistry"
          element={
            <HelmetWrapper title="IITTirupati - Chemistry">
              <RS_Chemistry />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/academics/research-scholars/researchscholars-chemistry"
          element={<Navigate to="/researchscholars-chemistry" replace />}
        />
        <Route
          path="/researchscholars-civi"
          element={
            <HelmetWrapper title="IITTirupati - Civil">
              <RS_CivilEng />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/academics/research-scholars/researchscholars-civil"
          element={<Navigate to="/researchscholars-civi" replace />}
        />
        <Route
          path="/researchscholars-cse"
          element={
            <HelmetWrapper title="IITTirupati - CSE">
              <RS_CSE />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/academics/research-scholars/researchscholars-cse"
          element={<Navigate to="/researchscholars-cse" replace />}
        />
        <Route
          path="/researchscholars-ee"
          element={
            <HelmetWrapper title="IITTirupati - Electrical Engineering">
              <RS_EE />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/academics/research-scholars/researchscholars-ee"
          element={<Navigate to="/researchscholars-ee" replace />}
        />
        <Route
          path="/researchscholars-mathematics"
          element={
            <HelmetWrapper title="IITTirupati - Mathematics and Statistic">
              <RS_MS />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/academics/research-scholars/researchscholars-mathematics"
          element={<Navigate to="/researchscholars-mathematicse" replace />}
        />
        <Route
          path="/researchscholars-me"
          element={
            <HelmetWrapper title="IITTirupati - Mechanical Engineering">
              <RS_ME />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/academics/research-scholars/researchscholars-me"
          element={<Navigate to="/researchscholars-me" replace />}
        />
        <Route
          path="/researchscholars-hss"
          element={
            <HelmetWrapper title="IITTirupati - Humanities & Social Sciences">
              <RS_HSS />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/academics/research-scholars/researchscholars-hss"
          element={<Navigate to="/researchscholars-hss" replace />}
        />
        <Route
          path="/researchscholars-physics"
          element={
            <HelmetWrapper title="IITTirupati - Physics">
              <RS_Physics />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/academics/research-scholars/researchscholars-physics"
          element={<Navigate to="/researchscholars-physics" replace />}
        />
        {/* other-fellowship*/}
        <Route
          path="/pmrf-scholars"
          element={
            <HelmetWrapper title="IITTirupati - PMRF">
              <Pmrf_Scholars />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/academics/other-fellowships/pmrf-scholars"
          element={<Navigate to="/pmrf-scholars" replace />}
        />
        <Route
          path="/prime-minister-s-fellowship"
          element={
            <HelmetWrapper title="IITTirupati - Prime Minister's Fellowship for Doctoral Research">
              <Pm_Fellowship />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/academics/other-fellowships/prime-minister-s-fellowship"
          element={<Navigate to="/prime-minister-s-fellowship" replace />}
        />
        {/* People */}
        <Route
          path="/chemical-engineering-department"
          element={
            <HelmetWrapper title="IITTirupati - Chemical Engineering">
              <Dept_ChemicalEng />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/people/faculty/chemical-engineering-department"
          element={<Navigate to="/chemical-engineering-department" replace />}
        />
        <Route
          path="/chemistry-department"
          element={
            <HelmetWrapper title="IITTirupati - Chemistry Department">
              <Dept_Chemistry />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/people/faculty/chemistry-department"
          element={<Navigate to="/chemistry-department" replace />}
        />
        <Route
          path="/civilengineering-department"
          element={
            <HelmetWrapper title="IITTirupati - Civill Engineering">
              <Dept_CivilEng />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/people/faculty/civilengineering-department"
          element={<Navigate to="/civilengineering-department" replace />}
        />
        <Route
          path="/computer-science-engineering-department"
          element={
            <HelmetWrapper title="IITTirupati - Computer Science Engineering">
              <Dept_CSE />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/people/faculty/computer-science-engineering-department"
          element={
            <Navigate to="/computer-science-engineering-department" replace />
          }
        />
        <Route
          path="/electrical-engineering-department"
          element={
            <HelmetWrapper title="IITTirupati - Electrical Engineering">
              <Dept_EE />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/people/faculty/electrical-engineering-department"
          element={<Navigate to="/electrical-engineering-department" replace />}
        />
        <Route
          path="/humanities-and-social-sciences-department"
          element={
            <HelmetWrapper title="IITTirupati - HUMANITIES AND SOCIAL SCIENCES">
              <Dept_HSS />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/people/faculty/humanities-and-social-sciences-department"
          element={
            <Navigate to="/humanities-and-social-sciences-department" replace />
          }
        />
        <Route
          path="/mathematics-department"
          element={
            <HelmetWrapper title="IITTirupati - Mathematics Department">
              <Dept_Math />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/people/faculty/mathematics-department"
          element={<Navigate to="/mathematics-department" replace />}
        />
        <Route
          path="/mechanical-engineering-department"
          element={
            <HelmetWrapper title="IITTirupati - Mechanical Engineering">
              <Dept_ME />
            </HelmetWrapper>
          }
        ></Route>{" "}
        {/* /o */}
        <Route
          path="/people/faculty/mechanical-engineering-department"
          element={<Navigate to="/mechanical-engineering-department" replace />}
        />
        <Route
          path="/physics-department"
          element={
            <HelmetWrapper title="IITTirupati - Physics Engineering">
              <Dept_Physics />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/people/faculty/physics-department"
          element={<Navigate to="/physics-department" replace />}
        />
        <Route
          path="/others"
          element={
            <HelmetWrapper title="IITTirupati - Other Guest Faculty">
              <Dept_OthersFacult />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/people/faculty/others"
          element={<Navigate to="/others" replace />}
        />
        {/* liaison */}
        <Route
          path="/liaison-officers"
          element={
            <HelmetWrapper title="IITTirupati - Liaison Officer ">
              <Liaison_officers />
            </HelmetWrapper>
          }
        ></Route>
        {/* <Route path="/policies" element={<HelmetWrapper title="IITTirupati - Policies "><Policies /></HelmetWrapper>} ></Route> */}
        {/* 30 */}
        {/* Rajbhasha */}
        <Route
          path="/rajbhasha"
          element={
            <HelmetWrapper title="IITTirupati - Rajbhasha">
              {" "}
              <Rajbhasha />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/rajbhasha"
          element={<Navigate to="/rajbhasha" replace />}
        />
        {/* Resource */}
        <Route
          path="/infrastructure"
          element={
            <HelmetWrapper title="IITTirupati - Infrastructure">
              <Infrastructure />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/computing-facilities"
          element={
            <HelmetWrapper title="IITTirupati - Computing Facilities">
              <Computing_facilities />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/resourcesacademics"
          element={
            <HelmetWrapper title="IITTirupati - Resources">
              <Resources_Academics />
            </HelmetWrapper>
          }
        ></Route>
        {/*  */}
        <Route
          path="/awards"
          element={
            <HelmetWrapper title="IITTirupati - Awards">
              <Awards />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/contact-iit"
          element={
            <HelmetWrapper title="IITTirupati - Contact IIT">
              <ContactUS />
            </HelmetWrapper>
          }
        ></Route>
        {/* Others */}
        <Route
          path="/openhouse"
          element={
            <HelmetWrapper title="IITTirupati - Open House">
              <Openhouse />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/committees"
          element={
            <HelmetWrapper title="IITTirupati - Committees">
              <Committees />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/internalcomplaintcommittee"
          element={
            <HelmetWrapper title="IITTirupati - Internal Complaint">
              <InternalComplaint />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/Timetable_Committee"
          element={
            <HelmetWrapper title="IITTirupati - Timetable Committee">
              <Timetable_Committee />
            </HelmetWrapper>
          }
        >        
        </Route>
        <Route
          path="/Service_Matters_Committee"
          element={
            <HelmetWrapper title="IITTirupati - Service Matters Committee">
              <Service_Matters_Committee />
            </HelmetWrapper>
          }
        >        
        </Route>
        <Route
          path="/RPN_Committee"
          element={
            <HelmetWrapper title="IITTirupati - RPN, Creation of Posts and Roster Verification Committee">
              <RPN_Committee />
            </HelmetWrapper>
          }
        >        
        </Route>
        <Route
          path="/Library_Advisory_Committee"
          element={
            <HelmetWrapper title="IITTirupati - Library Advisory Committee">
              <Library_Advisory_Committee />
            </HelmetWrapper>
          }
        >        
        </Route>
        <Route
          path="/anti-ragging"
          element={
            <HelmetWrapper title="IITTirupati - Anti Ragging">
              <AntiRagging />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/differently_abled_support_service_cell"
          element={
            <HelmetWrapper title="IITTirupati - Differently Abled Support Service Cell">
              <Differently_Abled_Support_Service_Cell />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/grievance_redressal_committee"
          element={
            <HelmetWrapper title="IITTirupati - Grievance Redressal Committee">
              <Grievance_Redressal_Committee />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/disciplinary_welfare_committee"
          element={
            <HelmetWrapper title="IITTirupati - Disciplinary and Welfare Committee">
              <Disciplinary_Welfare_Committee />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/school_management_committee"
          element={
            <HelmetWrapper title="IITTirupati - School Management Committee">
              <School_Management_Committee />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/senior-purchase-committee"
          element={
            <HelmetWrapper title="IITTirupati - Senior Purchase Committee">
              <Senior_Purchase_Committee />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/overseeing_waste_management_system"
          element={
            <HelmetWrapper title="IITTirupati - Overseeing Waste Management System">
              <Overseeing_Waste_Management_System />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/mental_health_and_well_being_monitoring_committee"
          element={
            <HelmetWrapper title="IITTirupati - Mental Health and Well-being Monitoring Committee">
              <Mental_Health_and_Well_Being_Monitoring_Committee />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/obc_cell"
          element={
            <HelmetWrapper title="IITTirupati - OBC Cell">
              <Obc_cell />
            </HelmetWrapper>
          }
        ></Route>

         <Route
          path="/outsourcing_contractual_adhoc_employee_committee"
          element={
            <HelmetWrapper title="IITTirupati - Outsourcing / Contractual / Adhoc Employee Committee">
              <Outsourcing_Contractual_Adhoc_Employee_Committee />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/equal_opportunity_cell"
          element={
            <HelmetWrapper title="IITTirupati - Equal Opportunity Cell">
              <Equal_Opportunity_Cell />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/creche"
          element={
            <HelmetWrapper title="IITTirupati - Creche">
              <Creche />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/kvsiittcampus"
          element={
            <HelmetWrapper title="IITTirupati - Kendriya Vidyalaya School">
              <Kvsiittcampus />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/information_for_btech_students"
          element={
            <HelmetWrapper title="IITTirupati - Information for Btech and Preparatory 2024 Students">
              <Information_for_btech_students />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/help-desk-girl-students"
          element={
            <HelmetWrapper title="IITTirupati - Help Desk @ Girl Students">
              <Help_desk_girl />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/our-stories/help-desk-girl-students"
          element={<Navigate to="/help-desk-girl-students" replace />}
        />
        <Route
          path="/bog-chairman"
          element={
            <HelmetWrapper title="IITTirupati - BoG Chairman">
              <Bog_chairman />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/alumni_Centres"
          element={
            <HelmetWrapper title="IITTirupati - Alumni Center">
              <Alumni_Centres />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/istem"
          element={
            <HelmetWrapper title="IITTirupati - I-STEM">
              <ISTEM />
            </HelmetWrapper>
          }
        ></Route>
        {/* Infrastucture */}
        <Route
          path="/infrastructure-at-transit-campus"
          element={
            <HelmetWrapper title="IITTirupati - Infrastructure @ Transit Campus">
              {" "}
              <InfrastructureCampus />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/inter-iit-sports-meet"
          element={
            <HelmetWrapper title="IITTirupati - Inter IIT Sports Meet">
              {" "}
              <Inter_iitsports />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/sports"
          element={
            <HelmetWrapper title="IITTirupati - Sports">
              {" "}
              <Sports />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/our-stories/activities/sports"
          element={<Navigate to="/sports" replace />}
        />
        <Route
          path="/219-sports-2"
          element={<Navigate to="/sports" replace />}
        />
        <Route
          path="/220-social"
          element={
            <HelmetWrapper title="IITTirupati - social">
              {" "}
              <Social />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/Club_Committee_Members"
          element={
            <HelmetWrapper title="IITTirupati - Club Committee Members">
              {" "}
              <Club_Committee_Members />{" "}
            </HelmetWrapper>
          }
        ></Route>
        {/* Activities */}
        <Route
          path="/festivals"
          element={
            <HelmetWrapper title="IITTirupati - Festivals">
              {" "}
              <Festival />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/our-stories/activities/festivals"
          element={<Navigate to="/festivals" replace />}
        />
        <Route
          path="/clubs"
          element={
            <HelmetWrapper title="IITTirupati - Clubs">
              {" "}
              <Clubs />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/our-stories/activities/clubs"
          element={<Navigate to="/clubs" replace />}
        />
        {/* Tendor */}
        <Route
          path="/tenders"
          element={
            <HelmetWrapper title="IITTirupati - Tenders">
              {" "}
              <Tenders />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/independent-external-monitors-iems"
          element={
            <HelmetWrapper title="IITTirupati - IEMs">
              {" "}
              <TendersIEMs />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/coming-soon"
          element={
            <HelmetWrapper title="IITTirupati - Coming-Soon">
              {" "}
              <ComingSoon />{" "}
            </HelmetWrapper>
          }
        ></Route>
        {/* -------------routes1 end here------------------- */}
        {/* Research Areas */}
        <Route
          path="/research-thrust-areas"
          element={
            <HelmetWrapper title="IITTirupati - Thrust Areas">
              {" "}
              <ResearchThrustAreasPg />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/research/research-thrust-areas"
          element={<Navigate to="/research-thrust-areas" replace />}
        />
        <Route
          path="/research-projects"
          element={
            <HelmetWrapper title="IITTirupati - Research Projects">
              {" "}
              <ResearchProjectsPg />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/research/projects"
          element={<Navigate to="/research-projects" replace />}
        />
        <Route
          path="/research-equipment"
          element={
            <HelmetWrapper title="IITTirupati - Equipment">
              {" "}
              <ResearchEquipmentPg />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/research/research-equipment"
          element={<Navigate to="/research-equipment" replace />}
        />
        <Route
          path="/incubation"
          element={
            <HelmetWrapper title="IITTirupati - Incubation">
              {" "}
              <IncubationPg />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/research/incubation"
          element={<Navigate to="/incubation" replace />}
        />
        <Route
          path="/patent-technology-transfer"
          element={
            <HelmetWrapper title="IITTirupati - Patent Technology Transfer">
              {" "}
              <PatentTechnologyTransferPg />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/research/patent-technology-transfer"
          element={<Navigate to="/patent-technology-transfer" replace />}
        />
        {/*Administration*/}
        <Route
          path="/acad-admin"
          element={
            <HelmetWrapper title="IITTirupati - Academic Administration">
              {" "}
              <AcademicAdministrationPg />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/leadership/acad-admin"
          element={<Navigate to="/acad-admin" replace />}
        />
        <Route
          path="/senate"
          element={
            <HelmetWrapper title="IITTirupati - Senate">
              <SenatePg />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/leadership/senate"
          element={<Navigate to="/senate" replace />}
        />
        <Route
          path="/board-of-governors"
          element={
            <HelmetWrapper title="IITTirupati - Board of Governors">
              <BoardOfGovernorsPg />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/leadership/board-of-governors"
          element={<Navigate to="/board-of-governors" replace />}
        />
        {/* Leadership */}
        <Route
          path="/finance-committee"
          element={
            <HelmetWrapper title="IITTirupati - Finance Committee">
              <FinanceComitteePg />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/leadership/finance-committee"
          element={<Navigate to="/finance-committee" replace />}
        />
        <Route
          path="/building-and-work-commitee"
          element={
            <HelmetWrapper title="IITTirupati - Building & Work Commitee">
              <BuildingandWorkCommiteePg />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/leadership/building-and-work-commitee"
          element={<Navigate to="/building-and-work-commitee" replace />}
        />
        <Route
          path="/organizational-structure"
          element={
            <HelmetWrapper title="IITTirupati - Organizational-structure">
              <OrganizationalStructurePg />
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/leadership/organizational-structure"
          element={<Navigate to="/organizational-structure" replace />}
        />
        {/* 31 */}
        {/*Academic*/}
        <Route
          path="/academic-forms"
          element={
            <HelmetWrapper title="IITTirupati - Forms">
              {" "}
              <FormsPg />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/academics/academic-forms"
          element={<Navigate to="/academic-forms" replace />}
        />
        <Route
          path="/btechtimetable"
          element={
            <HelmetWrapper title="IITTirupati - Time Table">
              {" "}
              <BtechTimetable />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/academics/timetable/btechtimetable"
          element={<Navigate to="/btechtimetable" replace />}
        />
        <Route
          path="/faqs"
          element={
            <HelmetWrapper title="IITTirupati - FAQ">
              {" "}
              <FaqsPg />{" "}
            </HelmetWrapper>
          }
        ></Route>
        {/*Registrar*/}
        <Route
          path="/registrar"
          element={
            <HelmetWrapper title="IITTirupati - Registrar">
              {" "}
              <RegistrarPg />{" "}
            </HelmetWrapper>
          }
        ></Route>
        {/*Director*/}
        <Route
          path="/director"
          element={
            <HelmetWrapper title="IITTirupati - Director">
              {" "}
              <DirectorPg />{" "}
            </HelmetWrapper>
          }
        ></Route>
        {/*Annual Reprts*/}
        <Route
          path="/annualreports"
          element={
            <HelmetWrapper title="IITTirupati - Annual Reports">
              {" "}
              <AnnualReportsPg />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/transportation"
          element={
            <HelmetWrapper title="IITTirupati - Transportation">
              {" "}
              <TransportAdministrationPg />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/rti"
          element={
            <HelmetWrapper title="IITTirupati - RTI">
              {" "}
              <RTIAdministrationPg />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/rti-section-4"
          element={
            <HelmetWrapper title="IITTirupati - RTI Section 4">
              {" "}
              <RTISection4AdministrationPg />{" "}
            </HelmetWrapper>
          }
        ></Route>
        {/* router 4 */}
        <Route
          path="/publications"
          element={
            <HelmetWrapper title="IITTirupati - Publications">
              {" "}
              <Publication />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/health-center"
          element={
            <HelmetWrapper title="IITTirupati - Health Center">
              {" "}
              <HealthCentre />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/announcements"
          element={
            <HelmetWrapper title="IITTirupati - Announcements">
              {" "}
              <Announcements />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/newsletter"
          element={
            <HelmetWrapper title="IITTirupati - Newsletter">
              {" "}
              <Newsletter />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/home-events-list"
          element={
            <HelmetWrapper title="IITTirupati - Home Events List">
              {" "}
              <HomeEventList />{" "}
            </HelmetWrapper>
          }
        ></Route>
        
        
        {/* <Route
          path="/event-submission"
          element={
            <HelmetWrapper title="IITTirupati - Event Submission">
              <EventSubmission />
            </HelmetWrapper>
          }
        /> */}
        
        <Route
          path="/cultural"
          element={
            <HelmetWrapper title="IITTirupati - Cultural">
              {" "}
              <Cultural />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/our-stories/activities/cultural"
          element={<Navigate to="/cultural" replace />}
        />
        {/* Admission */}
        <Route
          path="/ms-phd-international"
          element={
            <HelmetWrapper title="IITTirupati - MS/PhD International">
              {" "}
              <MsPhdInternational_admissionPg />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/m-tech-international"
          element={
            <HelmetWrapper title="IITTirupati - M-Tech. International">
              {" "}
              <MtechInternational_admissionPg />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/m-tech-admission"
          element={
            <HelmetWrapper title="IITTirupati - M-Tech. Admission">
              {" "}
              <Mtech_admissionPg />{" "}
            </HelmetWrapper>
          }
        ></Route>
        {/* <Route
          path="/test-mtss-admission"
          element={
            <HelmetWrapper title="IITTirupati - M-Tech. Self Sponsored Admission">
              {" "}
              <Test_MtechSelfSponsored_admissionPg />{" "}
            </HelmetWrapper>
          }
        ></Route> */}
        
        <Route
          path="/m-tech-self-sponsored-admission"
          element={
            <HelmetWrapper title="IITTirupati - M-Tech. Self-Sponsored Admission">
              {" "}
              <MtechSelfSponsored_admissionPg />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/m-tech-spot-admission"
          element={
            <HelmetWrapper title="IITTirupati - M-Tech. Spot Admission">
              {" "}
              <MtechSpot_admissionPg />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/master-of-public-policy-mpp-admission"
          element={
            <HelmetWrapper title="IITTirupati - Master of Public Policy">
              {" "}
              <MPPadmissionPg />{" "}
            </HelmetWrapper>
          }
        ></Route>
        {/* Acadmic */}
        <Route
          path="/timetable-pg"
          element={
            <HelmetWrapper title="IITTirupati - PG Time Table">
              {" "}
              <TimeTablePg />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/academics/timetable/timetable-pg"
          element={<Navigate to="/timetable-pg" replace />}
        />
        {/* People */}
        <Route
          path="/permanent-campus"
          element={
            <HelmetWrapper title="IITTirupati - Permanent Campus">
              {" "}
              <PermanentCampus />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/technical-talks"
          element={
            <HelmetWrapper title="IITTirupati - Technical Talks">
              {" "}
              <TechnicalTalks />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/conferences"
          element={
            <HelmetWrapper title="IITTirupati - Conferences">
              {" "}
              <Conferences />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/distinguished-lectures"
          element={
            <HelmetWrapper title="IITTirupati - Distinguished Lectures">
              {" "}
              <DistinguishedLectures />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/news"
          element={
            <HelmetWrapper title="IITTirupati - News">
              {" "}
              <News />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/institute-events"
          element={
            <HelmetWrapper title="IITTirupati - Institute Events">
              {" "}
              <InstituteEvents />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/workshops"
          element={
            <HelmetWrapper title="IITTirupati - Workshops">
              {" "}
              <Workshops />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/facultyrecruitment"
          element={
            <HelmetWrapper title="IITTirupati - Faculty Recruitment">
              {" "}
              <FacultyRecruitment
                activeIndex={12}
                title="Faculty Recruitment"
              />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/recruitment"
          element={
            <HelmetWrapper title="IITTirupati - Recruitment">
              {" "}
              <Recruitment activeIndex={15} title="Recruitment" />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/Interns_and_Apprentice"
          element={
            <HelmetWrapper title="IITTirupati - Interns and Apprentice">
              {" "}
              <Interns_and_Apprentice title="Interns and Apprentice" />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/Project_Positions"
          element={
            <HelmetWrapper title="IITTirupati - Project Positions">
              {" "}
              <Project_Positions title="Project Positions" />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/Outsourced_Positions"
          element={
            <HelmetWrapper title="IITTirupati - Outsourced Positions">
              {" "}
              <Outsourced_Positions title="Outsourced Positions" />{" "}
            </HelmetWrapper>
          }
        ></Route>
        {/* <Route path="/aboutus" element={<HelmetWrapper title="IITTirupati - About Logo"><AboutEle activeIndex={0} title="About Us" /></HelmetWrapper>} /> */}
        <Route
          path="/admin-staff"
          element={
            <HelmetWrapper title="IITTirupati - Staff">
              {" "}
              <Admin_Staff />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route
          path="/people/admin-staff"
          element={<Navigate to="/admin-staff" replace />}
        />
        <Route
          path="/past-convocations"
          element={
            <HelmetWrapper title="IITTirupati - Past Convocations">
              {" "}
              <Past_Convocations
                activeIndex={0}
                title="Past Convocations"
              />{" "}
            </HelmetWrapper>
          }
        ></Route>
        {/* <Route
          path="/profile"
          element={
            <HelmetWrapper title="IITTirupati - Edit Faculty Profile">
              <ProfileEditor />
            </HelmetWrapper>
          }
        />
        <Route
          path="/profile/edit"
          element={
            <HelmetWrapper title="IITTirupati - Edit Faculty Profile">
              <ProfileEditor />
            </HelmetWrapper>
          }
        />
        <Route path="/faculty/:subpage" element={<RedirectSubpage />} /> */}
        <Route path="/:subpage" element={<FacultyProfileSwitch />} />
        {/* <Route
          path="dr-test-faculty"
          element={
            <FacultyProfileSwitch
              subpage="dr-venkata-ramana-badarla"
              oldSubpage="00239"
            />
          }
        /> */}
        {/*Staffs*/}
        {/* <Route
          path="prof-muthukumar-palanisamy"
          element={<Muthukumar_Palanisamy />}
        /> */}
        {/* ALL STAFF */}
        {/* <Route
          path="/dr-sasidhar-gumma"
          element={
            <FacultyProfileSwitch
              subpage="dr-sasidhar-gumma"
              oldElement={<SasidharGumma />}
            />
          }
        /> */}
        {/* <Route path="/dr-durga-prasad-challa" element={<DurgaprasadChalla />} /> */}
        {/* <Route path="/dr-s-rajesh" element={<S_Rajesh />} /> */}
        {/* <Route path="/dr-anki-reddy-katha" element={<Ankireddy_katha />} /> */}
        <Route
          path="/swayamprabha"
          element={
            <HelmetWrapper title="IITTirupati - Swayam Prabha">
              {" "}
              <SwayamPrabha />{" "}
            </HelmetWrapper>
          }
        ></Route>
        <Route path="/404-error" element={<Error />} />
        <Route path="*" element={<Error />} />
      </Routes>
      <Footer />
    </>
  );
}

export default Index;
